import { Link } from "react-router-dom";
import { useState, useEffect } from "react";
import axios from "axios";
import config from "../../Common/Configurations/APIConfig";
import LayoutHeader from "../../Common/Layout/Header";
import LayoutSideBar from "../../Common/Layout/Sidebar";
import moment from "moment";
import UpdatePayment from "../Client-Info/UpdatePaymentModel"; // Add this import
import { Modal, Button } from "react-bootstrap";
import Select from "react-select";

export default function Payment() {
  const [lists, setLists] = useState([]);
  const [errors, setErrors] = useState({});
  const [btnSubmit, setBtnSubmit] = useState(true);
  const [totalPages, setTotalPages] = useState(0);
  const [pageSize, setPageSize] = useState(20);
  const [pageNumber, setPageNumber] = useState(1);
  const [data, setData] = useState([]);
  const [totalRecords, setTotalRecords] = useState(0);
  const [clients, setClients] = useState([]);
  const userId = localStorage.getItem("userId");
  const [showUpdatePaymentModal, setShowUpdatePaymentModal] = useState(false);
  const [selectedPayment, setSelectedPayment] = useState(null);

  const [filterValues, setFilterValues] = useState({
    clientId: "00000000-0000-0000-0000-000000000000",
    paymentStatus: "",
    paymentMethod: "",
  });
  const headerconfig = {
    headers: {
      Authorization: "Bearer " + localStorage.getItem("userToken"),
    },
  };

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilterValues({
      ...filterValues,
      [name]: value,
    });
  };
  const handleclear = () => {
    GetData(pageNumber);
    setFilterValues({
      clientId: "00000000-0000-0000-0000-000000000000",
      paymentStatus: "",
      paymentMethod: "",
    });
  };
  const handleSearch = () => {
    GetData(pageNumber);
  };
  const handleEditClick = (payment) => {
    setSelectedPayment(payment);
    setShowUpdatePaymentModal(true);
  };

  const handleCloseUpdateModal = () => {
    setShowUpdatePaymentModal(false);
    setSelectedPayment(null);
    GetData(pageNumber); // Refresh data after update
  };
  const GetPageData = (number) => {
    if (number >= 1 && number <= totalPages) {
      setPageNumber(number);
      GetData(number);
    }
  };

  const pageNumbers = [];
  for (let i = 1; i <= totalPages; i++) {
    pageNumbers.push(i);
  }

  const renderPageNumbers = pageNumbers.map((number) => {
    return (
      <li
        className="page-item"
        key={number}
        id={number}
        onClick={() => GetPageData(number)}
      >
        <Link className="page-link">{number}</Link>
      </li>
    );
  });

  const GetData = (number) => {
    axios
      .get(
        config.APIACTIVATEURL +
          config.GETPAYMENTS +
          "?userId=" +
          userId +
          "&pageNumber=" +
          number +
          "&pageSize=" +
          pageSize +
          "&clientId=" +
          filterValues.clientId +
          "&paymentStatus=" +
          filterValues.paymentStatus +
          "&paymentMethod=" +
          filterValues.paymentMethod,

        "",
        { ...headerconfig }
      )
      .then((response) => {
        setLists(response.data.data.data);
        setPageNumber(response.data.data.pageNumber);
        setPageSize(response.data.data.pageSize);
        setTotalPages(response.data.data.totalPages);
        setData(response.data.data);
        setTotalRecords(response.data.data.totalRecords);
      });
  };

  const GetClients = () => {
    axios
      .get(
        config.APIACTIVATEURL + config.GETALLCLIENTS + "?userId=" + userId,
        headerconfig
      )
      .then((response) => {
        setClients(response.data.data);
      });
  };
  const applyErrorClass = (field) =>
    field in errors && !errors[field] ? " form-control-danger" : "";

  useEffect(() => {
    GetData(pageNumber);
    GetClients();
  }, [pageNumber]);

  return (
    <div id="layout-wrapper">
      <LayoutHeader />
      <LayoutSideBar />
      <div className="main-content">
        <div className="page-content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-12">
                <div className="page-title-box d-sm-flex align-items-center justify-content-between">
                  <h4 className="mb-sm-0">Payments</h4>
                </div>
              </div>
            </div>
            <div className="alert alert-success ">
              <form autoComplete="off" noValidate>
                <div className="row">
                  <div className="col-lg-3">
                    <div className="mb-3">
                      <label>Client</label>
                      <Select
                        name="clientId"
                        value={
                          clients.find(
                            (c) => c.clientId === filterValues.clientId
                          )
                            ? {
                                value: filterValues.clientId,
                                label:
                                  clients.find(
                                    (c) => c.clientId === filterValues.clientId
                                  )?.clientName || "All",
                              }
                            : null
                        }
                        onChange={(selectedOption) =>
                          setFilterValues({
                            ...filterValues,
                            clientId: selectedOption
                              ? selectedOption.value
                              : "00000000-0000-0000-0000-000000000000",
                          })
                        }
                        options={[
                          {
                            value: "00000000-0000-0000-0000-000000000000",
                            label: "All",
                          },
                          ...clients.map((c) => ({
                            value: c.clientId,
                            label: c.clientName,
                          })),
                        ]}
                        isSearchable
                        placeholder="Select Client"
                      />
                    </div>
                  </div>
                  <div className="col-lg-3">
                    <div className="mb-3">
                      <label htmlFor="paymentStatus" className="form-label">
                        Payment Status
                      </label>
                      <select
                        name="paymentStatus"
                        value={filterValues.paymentStatus}
                        onChange={handleFilterChange}
                        className="form-select"
                      >
                        <option value="">All</option>
                        <option value="SUCCESS">SUCCESS</option>
                        <option value="PENDING">PENDING</option>
                      </select>
                    </div>
                  </div>
                  <div className="col-lg-3">
                    <div className="mb-3">
                      <label htmlFor="paymentMethod" className="form-label">
                        Payment Method
                      </label>
                      <select
                        id="paymentMethod"
                        name="paymentMethod"
                        className="form-select"
                        value={filterValues.paymentMethod}
                        onChange={handleFilterChange}
                      >
                        <option value="">All </option>
                        <option value="UPI">UPI</option>
                        <option value="NETBANKING">NETBANKING</option>
                        <option value="CREDITCARD">CREDITCARD</option>
                        <option value="DEBITCARD">DEBITCARD</option>
                        <option value="PAYPAL">PAYPAL</option>
                        <option value="RAZORPAY">RAZORPAY</option>
                        <option value="OTHERS">OTHERS</option>
                      </select>
                    </div>
                  </div>
                  <div className="col-md-3">
                    <div className="hstack gap-2 justify-content-middle mb-3 mt-4">
                      <button
                        type="button"
                        className="btn btn-primary w-100"
                        onClick={handleSearch}
                      >
                        Search
                      </button>
                      <button
                        type="button"
                        className="btn btn-danger w-100"
                        onClick={handleclear}
                      >
                        Clear
                      </button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
            <div className="row">
              <div className="col-xl-12">
                <div className="card card-height-100">
                  <div className="card-body">
                    <div className="table-responsive table-card">
                      <table className="table align-middle">
                        <thead className="table-light">
                          <tr>
                            <th>S.No</th>
                            <th>Client</th>
                            <th>Staff</th>
                            <th>Service</th>
                            <th>Amount</th>
                            <th>Payment Status</th>
                            <th>Created Date</th>
                            <th>Payment Date</th>
                            <th>Method</th>
                            <th>Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {lists && lists.length > 0 ? (
                            lists.map((v, index) => (
                              <tr key={v.paymentId}>
                                <td>
                                  {(pageNumber - 1) * pageSize + (index + 1)}
                                </td>
                                <td>{v.clientName}</td>
                                <td>{v.staffName}</td>
                                <td>{v.serviceName}</td>
                                <td>{v.amount}</td>
                                <td>
                                  <span
                                    className={
                                      "badge " +
                                      (v.paymentStatus === "SUCCESS"
                                        ? "bg-success"
                                        : "bg-warning")
                                    }
                                  >
                                    {v.paymentStatus}
                                  </span>
                                </td>
                                <td>
                                  {moment(v.createdDate).format(
                                    "DD-MM-YYYY hh:mm a"
                                  )}
                                </td>
                                <td>
                                  {v.paymentDate === "0001-01-01T00:00:00"
                                    ? "--"
                                    : moment(v.paymentDate).format(
                                        "DD-MM-YYYY hh:mm a"
                                      )}
                                </td>
                                <td>{v.paymentMethod}</td>
                                <td>
                                  <ul className="list-inline hstack gap-2 mb-0">
                                    <li
                                      className="list-inline-item"
                                      data-bs-toggle="tooltip"
                                      data-bs-trigger="hover"
                                      data-bs-placement="top"
                                      title="Edit"
                                    >
                                      <Link
                                        className="edit-item-btn"
                                        onClick={() => handleEditClick(v)}
                                      >
                                        <i className="ri-pencil-fill align-bottom text-muted" />
                                      </Link>
                                    </li>
                                  </ul>
                                </td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan="10" className="text-center">
                                No Data Available
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                    <div className="align-items-center mt-4 pt-2 justify-content-between d-flex">
                      <div className="flex-shrink-0">
                        <div className="text-muted">
                          Showing{" "}
                          <span className="fw-semibold">{lists.length}</span> of{" "}
                          <span className="fw-semibold">{totalRecords}</span>{" "}
                          Results
                        </div>
                      </div>
                      <ul className="pagination pagination-separated pagination-sm mb-0">
                        <li
                          className={
                            "page-item " + (pageNumber === 1 ? "disabled" : "")
                          }
                        >
                          <Link
                            className="page-link"
                            onClick={() => GetPageData(pageNumber - 1)}
                          >
                            Previous
                          </Link>
                        </li>
                        {renderPageNumbers}
                        <li
                          className={
                            "page-item " +
                            (pageNumber === totalPages ? "disabled" : "")
                          }
                        >
                          <Link
                            className="page-link"
                            onClick={() => GetPageData(pageNumber + 1)}
                          >
                            Next
                          </Link>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Add this at the end of your component, before the closing div tags */}
      {showUpdatePaymentModal && selectedPayment && (
        <UpdatePayment
          onClose={handleCloseUpdateModal}
          headerconfig={headerconfig}
          payment={selectedPayment}
        />
      )}
    </div>
  );
}
